<template>
  <div class="demo-app">
    <ModalAgendamento
      @dataSchedule="dataSchedule = $event"
      @getNewTypeOfSchedule="findAllTypeOfSchedule"
      @updateSchedule="handleStartSchedule"
      @clear="clearDataReadSchedule"
      :date="date"
      :dataReadSchedule="dataReadSchedule"
      :typeOfSchedule="typeOfSchedule"
    />
    <!-- <ModalVisualizar :dataReadSchedule="dataReadSchedule" /> -->
    <FullCalendar class="demo-app-calendar" :options="calendarOptions">
    </FullCalendar>
  </div>
</template>

<script>
import FullCalendar from "@fullcalendar/vue";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import ModalAgendamento from "./ModalAgendamento.vue";
// import ModalVisualizar from "./ModalVisualizar.vue";
import ServiceTypeOfSchedule from "../../services/serviceTypeOfSchedule";

import moment from "moment";
import api from "../../services/axios";
export default {
  components: {
    FullCalendar,
    ModalAgendamento,
    // ModalVisualizar,
  },

  data: function () {
    return {
      calendarOptions: {
        plugins: [
          dayGridPlugin,
          timeGridPlugin,
          interactionPlugin, // needed for dateClick
        ],
        buttonText: {
          today: "Hoje",
          month: "Mês",
          week: "Semana",
          day: "Dia",
        },
        views: {
          timeGridWeek: {
            titleFormat: { year: "numeric", month: "long", day: "numeric" },
          },
        },
        nowIndicator: true,
        slotMinTime: "08:00:00",
        slotMaxTime: "18:00:00",
        allDaySlot: false,
        initialView: "dayGridMonth",
        headerToolbar: {
          left: "prev,next",
          center: "title",
          right: "dayGridMonth,timeGridWeek,timeGridDay",
        },
        editable: true,
        selectable: true,
        selectMirror: true,
        dayMaxEvents: true,
        events: [],
        weekends: true,
        select: this.handleDateSelect,
        eventClick: this.handleDateSelect,
        eventsSet: this.handleEvents,
        datesSet: this.handleDateChange,
        locale: "pt-br",
        eventColor: "#3a4750",
        eventBorderColor: "#262e34",
      },
      currentEvents: [],
      dataSchedule: {},
      date: moment().format("YYYY-MM-DD HH:mm:ss"),
      dataReadSchedule: "",
      lastDateRange: {
        startStr: null,
        endStr: null,
      },
      typeOfSchedule: [],
    };
  },
  mounted() {
    this.handleStartSchedule();
    this.findAllTypeOfSchedule();
  },
  methods: {
    handleStartSchedule() {
      const today = moment().format("YYYY-MM-DD");
      this.lastDateRange.startStr = today;
      this.lastDateRange.endStr = today;
      this.readSchedule(this.lastDateRange.startStr, this.lastDateRange.endStr);
    },
    handleDateChange(info) {
      const last = this.lastDateRange;
      if (
        last.startStr === info.startStr.split("T")[0] &&
        last.endStr === info.endStr.split("T")[0]
      ) {
        return;
      }

      this.lastDateRange = {
        startStr: info.startStr.split("T")[0],
        endStr: info.endStr.split("T")[0],
      };

      this.readSchedule(this.lastDateRange.startStr, this.lastDateRange.endStr);
    },
    async readSchedule(startDate, endDate) {
      try {
        const { data } = await api.get(
          `/schedules?startDate=${startDate}&endDate=${endDate}`
        );

        this.calendarOptions.events = [];
        data.map((resultado) => {
          this.calendarOptions.events.push(this.CreateObject(resultado));
        });
      } catch (error) {
        console.log(error);
      }
    },
    CreateObject(dados) {
      return {
        id: dados.id,
        title: dados.tipo,
        start: moment(dados.dataAgenda).format("YYYY-MM-DD HH:mm:ss"),
        description: dados.descricao,
      };
    },
    clearDataReadSchedule() {
      this.dataReadSchedule = "";
    },
    handleWeekendsToggle() {
      this.calendarOptions.weekends = !this.calendarOptions.weekends;
    },

    async handleDateSelect(clickInfo) {
      if (clickInfo.event) {
        this.dataReadSchedule = clickInfo.event.id;
      }
      this.$bvModal.show("modal-Agendamento");
    },

    async handleEventClick(clickInfo) {
      this.dataReadSchedule = clickInfo.event.id;
      this.$bvModal.show("modal-Visualizar");
    },
    async findAllTypeOfSchedule() {
      try {
        this.typeOfSchedule = await ServiceTypeOfSchedule.fillComobobox();
      } catch (error) {
        this.$toast.open({
          message:
            error?.response?.data?.message ||
            "Ocorreu um problema ao buscar os tipos de agendamento",
          type: "info",
        });
      }
    },

    handleEvents(events) {
      this.currentEvents = events;
    },
  },
  watch: {
    dataSchedule() {
      this.calendarOptions.events.push(this.CreateObject(this.dataSchedule));
    },
  },
};
</script>

<style scoped>
.demo-app {
  display: flex;
  height: calc(100% - 50px);
  font-family: Arial, Helvetica Neue, Helvetica, sans-serif;
  font-size: 14px;
  background-color: #e9e9e9;
}
.demo-app-calendar {
  width: 65%;
  height: 90vh;
  max-width: 1100px;
  margin: 0 auto;
  padding: 1em;
  background: #ffffff91;
  color: black !important;
  text-transform: capitalize !important;
}
.fc,
.fc *,
.fc *:before,
.fc *:after {
  box-sizing: border-box;
  font-size: 13px;
}

@media screen and (max-width: 700px) {
  .demo-app-calendar {
    width: 100%;
    height: 90vh;
    margin: 0 auto;
    padding: 5px;
  }
  .fc,
  .fc *,
  .fc *:before,
  .fc *:after {
    font-size: 11px;
  }

  .fc .fc-toolbar-title {
    font-size: 13px;
    margin: 0;
    text-align: center;
  }

  .fc .fc-toolbar {
    display: flex;
    align-items: flex-end;
    flex-direction: column-reverse;
    justify-content: center;
  }
}
</style>
